import * as React from 'react';
import { Text, Title, Icon } from 'sg-styleguide';

import SelectButton from '../select-button/';
import PromoSystem from '../promo-system';
import PluginWrapper from '../../containers/plugin-wrapper';

import {
	SelectBoxWithBorder,
	FlexWithPadding,
	BoxWithPadding
} from '../helpers';

const PagePlugin = (props) => {
    return (
		<BoxWithPadding
			sm="4"
			padding={props.isPhone ? ['none', 'x-small', 'xx-small', 'x-small'] : ['none', 'small', 'large', 'small']}
		>
			<SelectBoxWithBorder
				label={ ( props.is_recommended ? window.wizardData.strings.recommended : '' ) }
				type="active"
			>
				<FlexWithPadding
					align="center"
					margin="none"
					padding={['medium', 'none', 'medium', 'none']}
					direction="column"
				>

					<img src={props.logo_url} width="50" height="50"/>

					<Title
						level="3"
						density="cozy"
						align="center"
					>
						{ window.wizardData.plugins[props.slug] ? window.wizardData.plugins[props.slug] : props.name }
					</Title>

					<SelectButton
						onClick={e => props.onClick(props.id)}
						text={window.wizardData.strings.select}
						selected={props.selected}
						textSelected={window.wizardData.strings.selected}
					/>
				</FlexWithPadding>
				<BoxWithPadding
					flex
					grow
					direction="column"
					className="ua-border-top ua-padding-medium"
				>
					{
						props.localeDescription &&
					<Text
						color="dark"
						className="ua-margin-bottom-medium"
					>
						{ props.localeDescription.description }
					</Text>
					}
					<PromoSystem
						price={props.getPrice()}
						partner={ window.wizardData.strings.plugin_by + " " + props.author}
					/>
				</BoxWithPadding>
			</SelectBoxWithBorder>
		</BoxWithPadding>
	);
};

export default PluginWrapper(PagePlugin);
